import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../style/style.css';
import '../style/sb-admin-2.min.css';
import '../font/css/all.min.css';
import logo from '../img/logos.png';

import {signIn} from '../Firebase/API/auth';
import {getAdmin} from '../Firebase/API/admin';
import {resetPassword} from '../Firebase/API/email';

function ForgotPassword(props) {

   const [email, setEmail] = useState('')
   
   const forgotPassword = (e) => {
      e.preventDefault();
      var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (!email || email === "") {
         toast.error("Please enter an Email.");
      }else if(!email.match(mailformat)){
         toast.error("Please enter valid Email.");
      }else if(email){
         resetPassword(email, (status)=>{
            if (status){
               setEmail("")
               toast.info("Reset Link has been sent to this email.")
            }
            else{
               toast.error("User not found with this email address.")
            }
         })
      }
   }
   
	
   return (
    <div >
    <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"/>
      <div className="row justify-content-center logins ">
         <div className="col-xl-12 col-lg-12 col-md-12 p-0">
            <div className="o-hidden border-0 ">
               <div className="p-0 bg" >
                  <div className="row " >
                     
                     <div className="col-xl-4 col-md-6 col-12 pt-5 login-right col-lg-5">
                        <div className="p-5">
                           <img src={logo} className="img-fluid" alt="Logo"/>
                           {/* <div className="text-center">
                              <h1 className="h4 mt-3 mb-0 text-left">Please login to your account</h1>
                            
                           </div> */}
                      
                           <form className="user">
                              <div className="form-group mt-2">
                                 
                                    <input type="email" className="form-control mt-4" id="emailaddress" required="" 
                                    value={email} onChange={(e) => setEmail(e.target.value)} aria-describedby="emailHelp"
                                    placeholder="Enter your Email"/>

                                    
									 
                                 <div className="d-flex justify-content-end mt-4">
                                    <button type="submit"  onClick={(e)=>forgotPassword(e)} className="btn btn-facebook btn-user d-block">
                                    Send Reset Link 
                                    </button>
                                 </div>
                                 <br></br>
                                 <a href="/" > Back To Login</a>


                              </div>
                           </form>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
    </div>

   
   );
}

export default ForgotPassword;

